export type SubjectFieldFilter = { key: string; value: string };

/** `key: null` sorts by creation date. */
export type SubjectFieldSort = { key: string | null; direction: 'ASC' | 'DESC' };

/** A field filter or sort needs a single type: the server rejects them without `typeId`. */
class FetchSubjects {
	constructor(
		public readonly accountId: number,
		public readonly typeId: number,
		public readonly search: string,
		public readonly page: number,
		public readonly rows: number,
		public readonly fieldFilters: readonly SubjectFieldFilter[] = [],
		public readonly fieldSort: SubjectFieldSort | null = null,
		public readonly includeArchived: boolean = false,
	) {
		Object.freeze(this);
	}

	toQueryString(): string {
		const params = new URLSearchParams({ typeId: String(this.typeId) });

		if (this.search.length > 0) {
			params.set('search', this.search);
		}

		for (const filter of this.fieldFilters) {
			params.append('fieldFilter', `${filter.key}:${filter.value}`);
		}

		// The server lists every dossier when `active` is absent: the client sends it itself, so
		// "include archived" stays expressible as the absence of this parameter.
		if (!this.includeArchived) {
			params.set('active', 'true');
		}

		params.set('page', String(this.page));
		params.set('rows', String(this.rows));

		if (this.fieldSort === null) {
			params.set('orderByCreatedAt', 'DESC');
		} else if (this.fieldSort.key === null) {
			params.set('orderByCreatedAt', this.fieldSort.direction);
		} else {
			params.set('orderByField', this.fieldSort.key);
			params.set('orderByFieldDirection', this.fieldSort.direction);
		}

		return params.toString();
	}
}

export default FetchSubjects;
